mutation CreateComplianceRecord($input: CreateComplianceRecordInput!) {
  createComplianceRecord(input: $input) {
    id
    contentId
    productId
    kind
    performerName
    note
    url
    fileName
    fileUrl
    createdAt
    updatedAt
  }
}
